window.axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if ((error.request || {}).status === 400) {
    localStorage.clear();
    window.location.reload(true);
  }
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/api/permission-interceptor.js